import React, { Component } from 'react';
import styled from 'styled-components';
import { formatByType } from 'helpers/formatNumbers';

const CellWrapper = styled.div``;

const NUMBER_FIELDS = ['percentage', 'floatX2', 'number', 'price'];

const isNumberField = (type, value) => typeof value === 'number' || NUMBER_FIELDS.includes(type);

const isNA = type => type === 'NOT_APPLICABLE';

class CellDiv extends Component {
    render() {
        const { value, type, strong, style = {}, disabled, ...rest } = this.props;
        const cellStyle = Object.assign({
            textAlign: isNumberField(type, value) || isNA(type) ? 'right' : 'left',
            fontWeight: `${strong ? 'bold' : 'normal'}`,
            width: '100%'
        }, style);

        if (disabled) {
            return (
                <CellWrapper style={{
                    background: 'repeating-linear-gradient(45deg, #fff, #fff 10px, #fafafa 10px, #fafafa 20px)'
                }}>&nbsp;
                </CellWrapper>
            );
        }

        return (
            <CellWrapper style={cellStyle} {...rest}>
                {type ? formatByType(value, type) : value}
            </CellWrapper>
        );
    }
}

export default CellDiv;



// WEBPACK FOOTER //
// ./src/components/molecules/tables/components/CellDiv.js